var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29215 11.9896C7.10226 12.1649 6.79438 12.1649 6.60448 11.9896L0.769452 6.60344C0.579558 6.42816 0.579558 6.14396 0.769452 5.96868L6.60448 0.58249C6.79438 0.407204 7.10226 0.407204 7.29215 0.58249C7.48204 0.757777 7.48204 1.04197 7.29215 1.21726L1.80095 6.28606L7.29215 11.3549C7.48204 11.5301 7.48204 11.8143 7.29215 11.9896Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.6d4bb8345a061f3f7a22365d96f2163e.svg";
export { ForwardRef as ReactComponent };